import { DateFields, Services, getServicePathToAPI, joinURLPath } from '@sigma-frontend-libs/commons'
import { OrderDirections } from '@sigmasms/shared-types'

import { globalErrorHandler, request, states } from '@/utils'

import render from './render'

const pathToAPI = getServicePathToAPI(Services['otp-handler'])

export default {
  name: 'Channel',

  props: {
    requestId: {
      type: String,
      default: undefined
    }
  },

  data() {
    return {
      state: states.empty,

      items: []
    }
  },

  computed: {
    hasItems() {
      return Array.isArray(this.items) && this.items.length > 0
    }
  },

  watch: {
    'pagination.offset'() {
      this.getItems()
    }
  },

  mounted() {
    this.getItems()
  },

  methods: {
    queryProcessor(query) {
      return {
        ...query,
        order: [ [ DateFields.createdAt, OrderDirections.DESC ] ]
      }
    },

    async getItems() {
      if (this.requestId) {
        try {
          this.state = states.loading
          const data = await request.get(joinURLPath(pathToAPI, 'channel'), undefined, this.queryProcessor({ requestId: this.requestId }))
          if (data?.data) {
            this.state = states.success
            this.items = data.data
          }
        } catch (error) {
          this.state = states.error
          globalErrorHandler(error)
        } finally {
          this.state = states.ready
        }
      }
    }
  },

  render
}
